import React from 'react'
import qr1 from '../assets/images/rate/qr1.png'
import qr2 from '../assets/images/rate/qr2.png'
import qr3 from '../assets/images/rate/qr3.png'
import qr4 from '../assets/images/rate/qr4.png'

export default function Rate() {
  const rateQrs = [
    {
      id: 1,
      qr: qr1,
      title: 'استبيان تقييم ملتقى تمكين X',
      link: 'https://forms.office.com/r/qgQaBCQvRb?origin=lprLink',
    },
    {
      id: 2,
      qr: qr2,
      title: 'استبيان تقييم الجلسة الحوارية لملتقى تمكين X',
      link: 'https://forms.office.com/r/sHUZkeTCXY?origin=lprLink',
    },
    {
      id: 3,
      qr: qr3,
      title: 'استبيان تقييم ورشة العمل لملتقى تمكين X ',
      link: 'https://forms.office.com/r/C0yLfLf8xW?origin=lprLink',
    },
    {
      id: 4,
      qr: qr4,
      title: 'استبيان تقييم جلسات الإرشاد المهني لملتقى تمكين X  ',
      link: 'https://forms.office.com/r/s4ayDSK2aV?origin=lprLink',
    },
  ]

  return (
    <section
      className="relative overflow-hidden bg-gradient-to-b from-slate-50 via-white to-slate-100 py-24 px-4"
      dir="rtl"
    >
      {/* Decorative blurs */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -right-10 top-10 h-48 w-48 rounded-full bg-sky-200 opacity-30 blur-3xl" />
        <div className="absolute -left-16 bottom-0 h-56 w-56 rounded-full bg-indigo-200 opacity-30 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-12 space-y-3">
          <p className="text-5xl font-bold text-sky-700">رأيك يهمنا</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {rateQrs.map((qr, idx) => (
            <RateCard key={qr.id} qr={qr} delay={idx * 80} />
          ))}
        </div>
      </div>
    </section>
  )
}

function RateCard({ qr, delay = 0 }) {
  return (
    <div
      className="
        group relative flex flex-col h-full
        rounded-2xl border border-slate-100 bg-white/90
        shadow-md hover:shadow-2xl transition
        duration-300 ease-out transform hover:-translate-y-2
        overflow-hidden
      "
      style={{ animation: `fadeUp 0.5s ease ${delay}ms both` }}
    >
      <div className="overflow-hidden bg-slate-50 p-8">
        <img
          src={qr.qr}
          alt={qr.title}
          className="w-full h-auto transition duration-300 group-hover:scale-105"
        />
      </div>

      <div className="p-5 flex flex-col gap-4 flex-1">
        <h3 className="text-lg font-bold text-slate-900 text-center leading-snug">
          {qr.title}
        </h3>

        <a
          href={qr.link}
          target="_blank"
          rel="noopener noreferrer"
          className="
            inline-flex w-full items-center justify-center gap-2
            text-sm font-semibold text-white
            bg-gradient-to-r from-sky-600 to-indigo-600
            rounded-full px-4 py-2
            transition duration-200
            hover:from-sky-500 hover:to-indigo-500
            focus:outline-none focus:ring-2 focus:ring-sky-300
            mt-auto
          "
        >
          اضغط هنا للتقييم
          <span className="text-base transition-transform group-hover:translate-x-1">
            ↗
          </span>
        </a>
      </div>
    </div>
  )
}

// Simple fade-up animation without external libs
const styles = `
@keyframes fadeUp {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}
`

// Inject keyframes once in the browser
if (typeof document !== 'undefined' && !document.getElementById('rate-anim')) {
  const styleTag = document.createElement('style')
  styleTag.id = 'rate-anim'
  styleTag.innerHTML = styles
  document.head.appendChild(styleTag)
}